import { useRouter } from '@/hooks/use-router';
import { useDynamicList } from '@/services/dynamic-resource';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from './command';
import { Icon } from './icon';

interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CommandPalette({ open, onOpenChange }: CommandPaletteProps) {
  const { push } = useRouter();

  const { data: salesResponse } = useDynamicList('sales', { perPage: 200 });
  const { data: customersResponse } = useDynamicList('customers', { perPage: 200 });

  const sales = salesResponse?.data ?? [];
  const customers = customersResponse?.data ?? [];

  const go = (href: string) => {
    onOpenChange(false);
    push(href);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Buscar pedido, cliente..." />
      <CommandList>
        <CommandEmpty>Nenhum resultado encontrado.</CommandEmpty>

        <CommandGroup heading="Pedidos">
          {sales.map((sale: any) => (
            <CommandItem
              key={sale.id}
              value={`${sale.saleNumber ?? sale.id} ${sale.customer?.name ?? ''}`}
              onSelect={() => go(`/sales/${sale.id}/view`)}
            >
              <Icon name="shopping-cart" className="size-4" />
              <span className="font-mono text-xs">
                {sale.saleNumber ?? sale.id.slice(0, 8)}
              </span>
              <span className="text-muted-foreground">{sale.customer?.name ?? '—'}</span>
            </CommandItem>
          ))}
        </CommandGroup>

        <CommandGroup heading="Clientes">
          {customers.map((customer: any) => (
            <CommandItem
              key={customer.id}
              value={`${customer.name} ${customer.phone ?? ''}`}
              onSelect={() => go(`/customers/${customer.id}/view`)}
            >
              <Icon name="user-round" className="size-4" />
              <span>{customer.name}</span>
              {customer.phone && (
                <span className="text-muted-foreground">{customer.phone}</span>
              )}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
